import { render, staticRenderFns } from "./Lite.vue?vue&type=template&id=2972ff56&"
import script from "./Lite.vue?vue&type=script&lang=js&"
export * from "./Lite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports